import React from 'react'
import {Icon} from '@chakra-ui/react'

const StarFilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M8.45027 8.73158L11.9999 1L15.5507 8.73158L24 9.7192L17.7443 15.4841L19.4159 23.8251L12 19.6575L4.58413 23.8251L6.2557 15.4841L0 9.71916L8.45027 8.73158Z"
                fill="#D11B59"
            />
        </Icon>
    )
}

export default StarFilledIcon
